module.exports = __webpack_public_path__ + "img/live_detail_icon3.ab4216fa.png";